import { IInvoiceServiceMock } from './invoice.mock.types';

export const mockInvoiceService = (): IInvoiceServiceMock => ({
  fetchInvoices: jest.fn(),
  fetchInvoice: jest.fn(),
  createInvoice: jest.fn(),
  updateInvoice: jest.fn(),
  deleteInvoice: jest.fn(),
  updateInvoiceState: jest.fn(),
  exportInvoice: jest.fn(),
  //Item
  fetchInvoiceItems: jest.fn(),
  fetchInvoiceItem: jest.fn(),
  createInvoiceItem: jest.fn(),
  updateInvoiceItem: jest.fn(),
  deleteInvoiceItem: jest.fn()
});
